import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from "react-router-dom";
import Rootlayout from "./components/layout/Rootlayout";
import AuctionListPopup from "./components/Popup/AuctionListPopup/AuctionListPopup";
import AuctionCustomDisplay from "./pages/AuctionCustomDisplay";
import AuctionListingDisplay from "./pages/AuctionListingDisplay";
import BusinessListing from "./pages/BusinessListing";
import BusinessListingDetails from "./pages/BusinessListingDetails";
import BusinessListingForm from "./pages/BusinessListingForm";
import BuyListingCustomDisplay from "./pages/BuyListingCustomDisplay";
import BuyListingDisplay from "./pages/BuyListingDisplay";
import Category from "./pages/Category";
import ClassifiedAdListingDisplay from "./pages/ClassifiedAdListingDisplay";
import ClassifiedAuctionPropertyCustomForm from "./pages/ClassifiedAuctionPropertyCustomForm";
import ClassifiedBuylistingPropertyCustomForm from "./pages/ClassifiedBuylistingPropertyCustomForm";
import ClassifiedCustomDisplay from "./pages/ClassifiedCustomDisplay";
import ClassifiedPropertyCustomFieldForm from "./pages/ClassifiedPropertyCustomFieldForm";
import ConfirmEmail from "./pages/ConfirmEmail";
import CreateAuctionListingForm from "./pages/CreateAuctionListingForm";
import CreateBuyListingForm from "./pages/CreateBuyListingForm";
import CreateClassifiedAdListingForm from "./pages/CreateClassifiedAdListingForm";
import Demo from "./pages/Demo";
import Home from "./pages/Home";
import LiveAnimalBuylistingCustomDetails from "./pages/LiveAnimalBuylistingCustomDetails";
import LiveAnimalClassifiedCustomDetails from "./pages/LiveAnimalClassifiedCustomDetails";
import LiveAnimalsBuylistingCustomFiledForm from "./pages/LiveAnimalsBuylistingCustomFiledForm";
import LiveAnimalsClassifiedCustomFieldForm from "./pages/LiveAnimalsClassifiedCustomFieldForm";
import Login from "./pages/Login";
import OtherAuctionCustomDisplay from "./pages/OtherAuctionCustomDisplay";
import OtherBuyCustomDisplay from "./pages/OtherBuyCustomDisplay";
import OtherClassifiedCustomDisplay from "./pages/OtherClassifiedCustomDisplay";
import OthersAuctionCustomFiledForm from "./pages/OthersAuctionCustomFiledForm";
import OthersBuylistingCustomForm from "./pages/OthersBuylistingCustomForm";
import OthersClassifiedCustomForm from "./pages/OthersClassifiedCustomForm";
import PopupDisplay from "./pages/PopupDisplay";
import Register from "./pages/Register";
import ResetPassword from "./pages/ResetPassword";
import UserAccount from "./pages/UserAccount";
import UserListing from "./pages/UserListing";

let router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<Rootlayout />}>
      <Route index element={<Home />} />
      <Route path="/category" element={<Category />} />
      <Route
        path="/auction-listing-display"
        element={<AuctionListingDisplay />}
      />
      <Route
        path="/auction-custom-display"
        element={<AuctionCustomDisplay />}
      />
      <Route
        path="/classified-ad-listing"
        element={<ClassifiedAdListingDisplay />}
      />
      <Route
        path="/classified-custom-display"
        element={<ClassifiedCustomDisplay />}
      />
      <Route path="/buylisting" element={<BuyListingDisplay />} />
      <Route
        path="/buylisting-custom-display"
        element={<BuyListingCustomDisplay />}
      />
      <Route
        path="/create-auctionlist-form"
        element={<CreateAuctionListingForm />}
      />
      <Route
        path="/create-classified-adlisting-form"
        element={<CreateClassifiedAdListingForm />}
      />
      <Route
        path="/classified-property-custom-form"
        element={<ClassifiedPropertyCustomFieldForm />}
      />
      <Route
        path="/auction-property-custom-form"
        element={<ClassifiedAuctionPropertyCustomForm />}
      />
      <Route
        path="/buylisting-property-custom-form"
        element={<ClassifiedBuylistingPropertyCustomForm />}
      />
      <Route
        path="/other-auction-custom-form"
        element={<OthersAuctionCustomFiledForm />}
      />
      <Route
        path="/other-auction-custom-display"
        element={<OtherAuctionCustomDisplay />}
      />
      <Route
        path="/other-classifed-custom-display"
        element={<OtherClassifiedCustomDisplay />}
      />
      <Route
        path="/other-buy-custom-display"
        element={<OtherBuyCustomDisplay />}
      />
      <Route
        path="/other-buylisting-custom-form"
        element={<OthersBuylistingCustomForm />}
      />
      <Route
        path="/other-classified-custom-form"
        element={<OthersClassifiedCustomForm />}
      />
      <Route
        path="/live-animals-classified-custom-form"
        element={<LiveAnimalsClassifiedCustomFieldForm />}
      />
      <Route
        path="/live-animals-buylisting-custom-form"
        element={<LiveAnimalsBuylistingCustomFiledForm />}
      />
      <Route
        path="/live-animals-buylisting-custom-details"
        element={<LiveAnimalBuylistingCustomDetails />}
      />
      <Route
        path="/live-animals-classified-custom-details"
        element={<LiveAnimalClassifiedCustomDetails />}
      />
      <Route
        path="/create-buylisting-form"
        element={<CreateBuyListingForm />}
      />
      <Route path="/business-listing" element={<BusinessListing />} />
      <Route path="/business-listing-form" element={<BusinessListingForm />} />
      <Route
        path="/business-listing-details"
        element={<BusinessListingDetails />}
      />
      <Route path="/userlisting" element={<UserListing />} />
      <Route path="/userlisting/*" element={<UserListing />} />
      <Route path="/user" element={<UserAccount />} />
      <Route path="/user/*" element={<UserAccount />} />
      <Route path="/login" element={<Login />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/register" element={<Register />} />
      <Route path="/confirm-email" element={<ConfirmEmail />} />
      <Route path="/popup-display" element={<PopupDisplay />} />
      <Route path="/popup-auction-list" element={<AuctionListPopup />} />
      <Route path="/demo" element={<Demo />} />
    </Route>
  )
);

function App() {
  return <RouterProvider router={router} />;
  // return (
  //   <div className="flex min-h-screen items-center justify-center">
  //     <p className="font-pop text-3xl font-medium ">Temporarily down...</p>
  //   </div>
  // );
}

export default App;
